<template>
  <div class="hc-wrap">
    <ProgressBar v-if="loader" mode="indeterminate"
      style="height:3px;position:fixed;top:0;left:0;right:0;z-index:9999;border-radius:0"/>

    <!-- ── Selección de empresa (Generador puede trabajar con varias transportadoras) ── -->
    <div class="hc-empresa-selector" v-if="idRolActivo == 2 && customer_selected == null">
      <div class="hc-empresa-icon"><i class="pi pi-building"></i></div>
      <div class="hc-empresa-body">
        <div class="hc-empresa-title">Seleccione la empresa de transporte</div>
        <Dropdown v-model="customer_selected" :showClear="true"
          :options="customers_group" optionLabel="name" optionValue="id_customer"
          placeholder="Seleccione una empresa…" style="width:100%;max-width:420px"
          @change="onEmpresaSeleccionada" />
      </div>
    </div>

    <template v-if="idRolActivo != 2 || customer_selected != null">

    <!-- ── Topbar ── -->
    <div class="hc-topbar">
      <div>
        <h2 class="hc-title">
          Hoja de Vida de Conductores
          <span class="hc-badge-total">{{ pagination.total }}</span>
        </h2>
        <p class="hc-sub">Gestión y seguimiento de conductores de la flota</p>
      </div>
      <div class="hc-topbar-actions">
        <button class="hc-btn-outline" @click="toggleFiltros">
          <i class="pi pi-filter"></i> Filtrar
        </button>
        <button class="hc-btn-primary" @click="mostrarModalNuevo = true">
          <i class="pi pi-plus-circle"></i> Nuevo Conductor
        </button>
      </div>
    </div>

    <!-- ── OverlayPanel Filtros ── -->
    <OverlayPanel ref="opFiltros" appendTo="body" :showCloseIcon="true" :style="{width:'440px'}">
      <div class="hc-filtros">
        <div class="hc-filtros-title"><i class="pi pi-filter"></i> Filtrar conductores</div>

        <div class="hc-filtros-field">
          <label>Nombre o documento</label>
          <span class="p-input-icon-left" style="width:100%">
            <i class="pi pi-search"></i>
            <InputText v-model="frmfiltros.busqueda" placeholder="Buscar por nombre o cédula…"
              style="width:100%" @keydown.enter="aplicarFiltros" />
          </span>
        </div>

        <div class="hc-filtros-grid">
          <div class="hc-filtros-field">
            <label>Estado conductor</label>
            <Dropdown v-model="frmfiltros.estado_conductor" :options="opciones_estado_conductor"
              optionLabel="label" optionValue="value" placeholder="Todos"
              :showClear="true" style="width:100%" />
          </div>
          <div class="hc-filtros-field">
            <label>Estado licencia</label>
            <Dropdown v-model="frmfiltros.estado_licencia" :options="opciones_estado_licencia"
              optionLabel="label" optionValue="value" placeholder="Todos"
              :showClear="true" style="width:100%" />
          </div>
          <div class="hc-filtros-field">
            <label>Comparendos</label>
            <Dropdown v-model="frmfiltros.tiene_comparendos" :options="opciones_si_no"
              optionLabel="label" optionValue="value" placeholder="Todos"
              :showClear="true" style="width:100%" />
          </div>
          <div class="hc-filtros-field">
            <label>Antecedentes</label>
            <Dropdown v-model="frmfiltros.tiene_antecedentes" :options="opciones_si_no"
              optionLabel="label" optionValue="value" placeholder="Todos"
              :showClear="true" style="width:100%" />
          </div>
        </div>

        <div class="hc-filtros-actions">
          <button class="hc-btn-outline" @click="limpiarFiltros">
            <i class="pi pi-filter-slash"></i> Limpiar
          </button>
          <button class="hc-btn-primary" @click="aplicarFiltros">
            <i class="pi pi-search"></i> Buscar
          </button>
        </div>
      </div>
    </OverlayPanel>

    <!-- ── Tabla ── -->
    <div class="hc-tabla-wrap">

      <div v-if="!loader && conductores.length === 0" class="hc-empty">
        <div class="hc-empty-icon"><i class="pi pi-users"></i></div>
        <h3>No hay conductores registrados</h3>
        <p>Comienza registrando el primer conductor para tu flota.</p>
        <button class="hc-btn-primary" @click="mostrarModalNuevo = true">
          <i class="pi pi-plus"></i> Crear el primer conductor
        </button>
      </div>

      <table v-else class="hc-tabla">
        <thead>
          <tr>
            <th style="width:52px">Foto</th>
            <th style="width:130px">Documento</th>
            <th>Nombre</th>
            <th style="width:120px">Celular</th>
            <th style="width:120px">Licencia</th>
            <th style="width:110px">Comparendos</th>
            <th style="width:100px">Antecedentes</th>
            <th style="width:115px">Última Sync.</th>
            <th style="width:90px">Estado</th>
            <th style="width:90px">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="loader">
            <tr v-for="n in 6" :key="'sk'+n">
              <td colspan="10"><div class="hc-skeleton-row"></div></td>
            </tr>
          </template>
          <template v-else>
            <tr v-for="(data, i) in conductores" :key="i">

              <!-- Foto -->
              <td>
                <div class="hc-foto-wrap">
                  <img v-if="fotoConductor(data)" :src="fotoConductor(data)" class="hc-foto" alt="foto" />
                  <div v-else class="hc-foto-placeholder"><i class="pi pi-user"></i></div>
                </div>
              </td>

              <!-- Documento -->
              <td>
                <span class="hc-doc-badge">{{ data.document_id }}</span>
                <div v-if="!data.sincronizado" class="hc-sub mt-1">
                  <span class="hc-tag-sec">Sin sync</span>
                </div>
              </td>

              <!-- Nombre -->
              <td>
                <strong class="hc-strong">{{ nombreCompleto(data) }}</strong>
                <div class="hc-sub">{{ cAttr(data,'Email') || '' }}</div>
              </td>

              <!-- Celular -->
              <td><span class="hc-sub" style="font-size:.82rem;color:#374151">{{ cAttr(data,'Celular') || '—' }}</span></td>

              <!-- Licencia -->
              <td>
                <span :class="['hc-status', licenciaEstado(data).cls]">{{ licenciaEstado(data).label }}</span>
                <div class="hc-sub">{{ licenciaVence(data) }}</div>
              </td>

              <!-- Comparendos -->
              <td>
                <span :class="['hc-count', nComparendos(data) > 0 ? 'hc-count--danger' : 'hc-count--ok']">
                  {{ nComparendos(data) }}
                </span>
                <div v-if="nComparendos(data) > 0" class="hc-sub hc-rojo">
                  {{ fmtCOP(totalMultas(data)) }}
                </div>
              </td>

              <!-- Antecedentes -->
              <td>
                <span :class="['hc-status', tieneAntecedentes(data) ? 'hc-status--danger' : 'hc-status--ok']">
                  {{ tieneAntecedentes(data) ? 'SÍ' : 'NO' }}
                </span>
              </td>

              <!-- Última Sync -->
              <td><span class="hc-sync-fecha">{{ data.updated_at ? fmtFecha(data.updated_at) : '—' }}</span></td>

              <!-- Estado -->
              <td>
                <span :class="['hc-status', estadoConductor(data) === 'ACTIVO' ? 'hc-status--ok' : 'hc-status--sec']">
                  {{ estadoConductor(data) }}
                </span>
              </td>

              <!-- Acciones -->
              <td>
                <div class="hc-acciones">
                  <button class="hc-btn-icon" title="Ver detalle" @click="verDetalle(data)">
                    <i class="pi pi-eye"></i>
                  </button>
                  <button
                    :class="['hc-btn-icon',
                      data._sync_estado === 'ok'         ? 'hc-btn-icon--ok'
                      : data._sync_estado === 'en_proceso' ? 'hc-btn-icon--warn'
                      : data._sync_estado === 'error'      ? 'hc-btn-icon--danger'
                      : '']"
                    :title="data._sync_estado === 'en_proceso' ? 'En proceso…'
                          : data._sync_estado === 'error'      ? 'Error — reintentar'
                          : 'Resincronizar'"
                    :disabled="data._sincronizando"
                    @click="resincronizar(data)">
                    <i :class="data._sincronizando ? 'pi pi-spin pi-spinner'
                              : data._sync_estado === 'ok'         ? 'pi pi-check'
                              : data._sync_estado === 'en_proceso' ? 'pi pi-clock'
                              : data._sync_estado === 'error'      ? 'pi pi-times'
                              : 'pi pi-refresh'"></i>
                  </button>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <!-- Paginación -->
      <div class="hc-pagination" v-if="conductores.length > 0 || pagination.total > 0">
        <div class="hc-pagination-left">
          <span class="hc-pag-label">Filas por página</span>
          <select class="hc-per-page" v-model="porPagina" @change="cargarConductores(1)">
            <option :value="25">25</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>
        <span class="hc-pag-info">{{ pagination.from }}–{{ pagination.to }} de {{ pagination.total }}</span>
        <Paginator :rows="pagination.per_page" :totalRecords="pagination.total"
          @page="onChangePage" class="hc-paginator" />
      </div>
    </div>

    <!-- ══ MODAL DETALLE ══ -->
    <Dialog v-model:visible="modalDetalle" :style="{width:'82vw'}" :modal="true"
      header="Hoja de Vida del Conductor" class="hc-dialog">
      <div v-if="sel">

        <!-- Header conductor -->
        <div class="hc-modal-header">
          <div class="hc-foto-header-wrap">
            <img v-if="fotoConductor(sel)" :src="fotoConductor(sel)" class="hc-foto-header" alt="foto" />
            <div v-else class="hc-foto-header-placeholder"><i class="pi pi-user"></i></div>
          </div>
          <div class="hc-modal-main">
            <div class="hc-doc-badge-lg">{{ sel.document_id }}</div>
            <div class="hc-modal-title">{{ nombreCompleto(sel) }}</div>
            <div class="hc-modal-sub">{{ cAttr(sel,'Celular') }} · {{ cAttr(sel,'Email') }}</div>
          </div>
          <div class="hc-modal-badges">
            <div class="hc-badge-item">
              <span class="hc-badge-lbl">Licencia</span>
              <span :class="['hc-status', licenciaEstado(sel).cls]">{{ licenciaEstado(sel).label }}</span>
            </div>
            <div class="hc-badge-item">
              <span class="hc-badge-lbl">Comparendos</span>
              <span :class="['hc-count', nComparendos(sel)===0?'hc-count--ok':'hc-count--danger']">
                {{ nComparendos(sel) === 0 ? 'Sin deuda' : nComparendos(sel) }}
              </span>
            </div>
            <div class="hc-badge-item">
              <span class="hc-badge-lbl">Antecedentes</span>
              <span :class="['hc-status', tieneAntecedentes(sel)?'hc-status--danger':'hc-status--ok']">
                {{ tieneAntecedentes(sel) ? 'SÍ' : 'NO' }}
              </span>
            </div>
            <div class="hc-badge-item">
              <span class="hc-badge-lbl">Estado</span>
              <span :class="['hc-status', estadoConductor(sel)==='ACTIVO'?'hc-status--ok':'hc-status--sec']">
                {{ estadoConductor(sel) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <TabView class="hc-tabview mt-3">

          <!-- Datos personales -->
          <TabPanel>
            <template #header><i class="pi pi-user mr-2"></i>Datos Personales</template>
            <div class="hc-seccion-grid">

              <div class="hc-seccion">
                <div class="hc-seccion-titulo"><i class="pi pi-id-card"></i> Identificación</div>
                <div class="hc-kv-grid">
                  <span class="hc-kv-lbl">Tipo Doc.</span>     <span class="hc-mono">{{ cAttr(sel,'Tipo_documento') || '—' }}</span>
                  <span class="hc-kv-lbl">Documento</span>     <span class="hc-mono hc-bold">{{ sel.document_id }}</span>
                  <span class="hc-kv-lbl">Nombre completo</span><span class="hc-bold">{{ _runtp(sel)?.datos_persona?.nombre_completo || nombreCompleto(sel) }}</span>
                  <span class="hc-kv-lbl">Nombres</span>       <span>{{ cAttr(sel,'Nombres') || '—' }}</span>
                  <span class="hc-kv-lbl">Apellidos</span>     <span>{{ cAttr(sel,'Apellidos') || '—' }}</span>
                  <span class="hc-kv-lbl">Género</span>        <span>{{ cAttr(sel,'genero')==='M'?'Masculino':cAttr(sel,'genero')==='F'?'Femenino':'—' }}</span>
                  <span class="hc-kv-lbl">Nacimiento</span>    <span>{{ fmtFechaISO(cAttr(sel,'fecha_nacimiento')) }}</span>
                  <span class="hc-kv-lbl">Expedición</span>    <span>{{ fmtFechaISO(cAttr(sel,'Fecha_expedicion')) }}</span>
                  <span class="hc-kv-lbl">Estatura</span>      <span>{{ cAttr(sel,'estatura') ? cAttr(sel,'estatura')+' m' : '—' }}</span>
                  <span class="hc-kv-lbl">Sangre</span>
                  <span>
                    <span v-if="cAttr(sel,'grupo_sanguinio')" class="hc-status hc-status--danger">{{ cAttr(sel,'grupo_sanguinio') }}</span>
                    <span v-else>—</span>
                  </span>
                  <span class="hc-kv-lbl">País</span>           <span>{{ cAttr(sel,'Pais') || '—' }}</span>
                </div>
              </div>

              <div class="hc-seccion">
                <div class="hc-seccion-titulo"><i class="pi pi-phone"></i> Contacto</div>
                <div class="hc-kv-grid">
                  <span class="hc-kv-lbl">Email</span>   <span>{{ cAttr(sel,'Email') || 'No registrado' }}</span>
                  <span class="hc-kv-lbl">Celular</span> <span class="hc-mono">{{ cAttr(sel,'Celular') || 'No registrado' }}</span>
                  <template v-if="_ruaf(sel)?.afiliacion_a_salud?.filas?.[0] || _ruaf(sel)?.afiliacion_a_salud?.[0]">
                    <span class="hc-kv-lbl">Municipio</span>
                    <span>{{ (_ruaf(sel)?.afiliacion_a_salud?.filas?.[0] ?? _ruaf(sel)?.afiliacion_a_salud?.[0])?.departamento_municipio || '—' }}</span>
                  </template>
                </div>
              </div>

              <div class="hc-seccion">
                <div class="hc-seccion-titulo"><i class="pi pi-check-circle"></i> Estado RUNT</div>
                <div class="hc-kv-grid">
                  <span class="hc-kv-lbl">Estado persona</span>
                  <span>
                    <span :class="['hc-status', _runtp(sel)?.datos_persona?.estado_persona==='ACTIVA'?'hc-status--ok':'hc-status--warn']">
                      {{ _runtp(sel)?.datos_persona?.estado_persona || '—' }}
                    </span>
                  </span>
                  <span class="hc-kv-lbl">Estado conductor</span>
                  <span>
                    <span :class="['hc-status', _runtp(sel)?.datos_persona?.estado_conductor==='ACTIVO'?'hc-status--ok':'hc-status--warn']">
                      {{ _runtp(sel)?.datos_persona?.estado_conductor || '—' }}
                    </span>
                  </span>
                  <span class="hc-kv-lbl">N° Inscripción</span>  <span class="hc-mono">{{ _runtp(sel)?.datos_persona?.numero_inscripcion || '—' }}</span>
                  <span class="hc-kv-lbl">Fecha inscripción</span><span>{{ _runtp(sel)?.datos_persona?.fecha_inscripcion || '—' }}</span>
                </div>
              </div>

            </div>
          </TabPanel>

          <!-- Licencias -->
          <TabPanel>
            <template #header><i class="pi pi-car mr-2"></i>Licencias de Conducción</template>
            <div v-if="!licenciasList(sel).length" class="hc-empty-tab">
              <i class="pi pi-times-circle"></i> Sin licencias registradas
            </div>
            <div v-for="(lic,i) in licenciasList(sel)" :key="i"
              class="hc-poliza-card" :class="lic.estado==='ACTIVA'?'hc-poliza-vigente':''">
              <div class="hc-poliza-header">
                <span class="hc-poliza-entidad">{{ lic.ot_expide_lic }}</span>
                <span :class="['hc-status', lic.estado==='ACTIVA'?'hc-status--ok':'hc-status--sec']">{{ lic.estado }}</span>
              </div>
              <div class="hc-poliza-kv">
                <div><span class="hc-kv-lbl">N° Licencia</span><span class="hc-mono">{{ lic.nro_licencia }}</span></div>
                <div><span class="hc-kv-lbl">Categoría</span><span>{{ lic.categoria || '—' }}</span></div>
                <div><span class="hc-kv-lbl">Expedición</span><span>{{ lic.fecha_expedicion }}</span></div>
                <div><span class="hc-kv-lbl">Retención</span><span>{{ lic.retencion || '—' }}</span></div>
                <div><span class="hc-kv-lbl">Restricciones</span><span>{{ lic.restricciones || '—' }}</span></div>
              </div>
            </div>
          </TabPanel>

          <!-- Seguridad Social -->
          <TabPanel>
            <template #header><i class="pi pi-heart mr-2"></i>Seguridad Social</template>
            <div class="hc-seccion-grid">

              <div class="hc-seccion" v-if="(_ruaf(sel)?.afiliacion_a_salud?.filas ?? _ruaf(sel)?.afiliacion_a_salud ?? []).length">
                <div class="hc-seccion-titulo"><i class="pi pi-heart"></i> Salud</div>
                <div v-for="(s,i) in (_ruaf(sel)?.afiliacion_a_salud?.filas ?? _ruaf(sel)?.afiliacion_a_salud ?? [])" :key="i" class="hc-kv-grid mb-2">
                  <span class="hc-kv-lbl">Administradora</span><span>{{ s.administradora }}</span>
                  <span class="hc-kv-lbl">Régimen</span>       <span>{{ s.regimen }}</span>
                  <span class="hc-kv-lbl">Tipo afiliado</span> <span>{{ s.tipo_de_afiliado }}</span>
                  <span class="hc-kv-lbl">Estado</span>
                  <span><span :class="['hc-status', s.estado_de_afiliacion==='Activo'?'hc-status--ok':'hc-status--warn']">{{ s.estado_de_afiliacion }}</span></span>
                  <span class="hc-kv-lbl">Municipio</span>     <span>{{ s.departamento_municipio }}</span>
                </div>
              </div>

              <div class="hc-seccion" v-if="(_ruaf(sel)?.afiliacion_a_pensiones?.filas ?? _ruaf(sel)?.afiliacion_a_pensiones ?? []).length">
                <div class="hc-seccion-titulo"><i class="pi pi-wallet"></i> Pensiones</div>
                <div v-for="(p,i) in (_ruaf(sel)?.afiliacion_a_pensiones?.filas ?? _ruaf(sel)?.afiliacion_a_pensiones ?? [])" :key="i" class="hc-kv-grid mb-2">
                  <span class="hc-kv-lbl">Administradora</span><span>{{ p.administradora }}</span>
                  <span class="hc-kv-lbl">Régimen</span>       <span>{{ p.regimen }}</span>
                  <span class="hc-kv-lbl">Estado</span>
                  <span><span :class="['hc-status', p.estado_de_afiliacion?.toLowerCase().includes('activ')?'hc-status--ok':'hc-status--warn']">{{ p.estado_de_afiliacion }}</span></span>
                </div>
              </div>

              <div class="hc-seccion" v-if="(_ruaf(sel)?.afiliacion_a_riesgos_laborales?.filas ?? _ruaf(sel)?.afiliacion_a_riesgos_laborales ?? []).length">
                <div class="hc-seccion-titulo"><i class="pi pi-shield"></i> ARL</div>
                <div v-for="(r,i) in (_ruaf(sel)?.afiliacion_a_riesgos_laborales?.filas ?? _ruaf(sel)?.afiliacion_a_riesgos_laborales ?? [])" :key="i" class="hc-kv-grid mb-2">
                  <span class="hc-kv-lbl">Administradora</span><span>{{ r.administradora }}</span>
                  <span class="hc-kv-lbl">Municipio</span>     <span>{{ r.municipio_labora }}</span>
                  <span class="hc-kv-lbl">Estado</span>
                  <span><span :class="['hc-status', r.estado_de_afiliacion==='Activa'?'hc-status--ok':'hc-status--warn']">{{ r.estado_de_afiliacion }}</span></span>
                </div>
              </div>

              <div v-if="!(_ruaf(sel)?.afiliacion_a_salud?.filas ?? _ruaf(sel)?.afiliacion_a_salud ?? []).length
                      && !(_ruaf(sel)?.afiliacion_a_pensiones?.filas ?? _ruaf(sel)?.afiliacion_a_pensiones ?? []).length
                      && !(_ruaf(sel)?.afiliacion_a_riesgos_laborales?.filas ?? _ruaf(sel)?.afiliacion_a_riesgos_laborales ?? []).length"
                class="hc-empty-tab">
                <i class="pi pi-times-circle"></i> Sin datos de seguridad social
              </div>
            </div>
          </TabPanel>

          <!-- SIMIT -->
          <TabPanel>
            <template #header>
              <i class="pi pi-exclamation-triangle mr-2"></i>SIMIT
              <span v-if="nComparendos(sel)>0" class="hc-tab-badge">{{ nComparendos(sel) }}</span>
            </template>
            <div v-if="nComparendos(sel)===0" class="hc-simit-clean">
              <i class="pi pi-check-circle hc-simit-icon"></i>
              <strong>¡Sin comparendos!</strong>
              <p>{{ _simit(sel)?.estado_general }}</p>
            </div>
            <template v-else>
              <div class="hc-deuda-resumen mb-3">
                <div class="hc-deuda-item">
                  <span class="hc-kv-lbl">Comparendos</span>
                  <span class="hc-count hc-count--danger">{{ nComparendos(sel) }}</span>
                </div>
                <div class="hc-deuda-item">
                  <span class="hc-kv-lbl">Multas</span>
                  <span class="hc-count hc-count--warn">{{ _simit(sel)?.resumen?.multas ?? 0 }}</span>
                </div>
                <div class="hc-deuda-item">
                  <span class="hc-kv-lbl">Total a pagar</span>
                  <strong class="hc-deuda-total">{{ fmtCOP(_simit(sel)?.resumen?.total_pagar) }}</strong>
                </div>
              </div>
              <table class="hc-tabla hc-tabla--sm">
                <thead><tr>
                  <th style="width:105px">Fecha</th>
                  <th>Secretaría</th>
                  <th>Estado</th>
                  <th style="width:110px">Valor</th>
                </tr></thead>
                <tbody>
                  <tr v-for="(c,i) in comparendosList(sel)" :key="i">
                    <td>{{ c.fecha_imposicion }}</td>
                    <td><span class="hc-sub" style="font-size:.8rem;color:#374151">{{ c.secretaria }}</span></td>
                    <td>
                      <span :class="['hc-status', c.estado?.toLowerCase().includes('coactivo')?'hc-status--danger':'hc-status--warn']">
                        {{ c.estado }}
                      </span>
                    </td>
                    <td><span class="hc-monto">{{ fmtCOP(c.valor_cop) }}</span></td>
                  </tr>
                </tbody>
              </table>
            </template>
          </TabPanel>

          <!-- Multas RUNT -->
          <TabPanel>
            <template #header>
              <i class="pi pi-ban mr-2"></i>Multas RUNT
              <span v-if="multasRunt(sel).length>0" class="hc-tab-badge hc-tab-badge--warn">{{ multasRunt(sel).length }}</span>
            </template>
            <div v-if="!multasRunt(sel).length" class="hc-empty-tab">
              <i class="pi pi-check-circle"></i> Sin multas registradas en RUNT
            </div>
            <table v-else class="hc-tabla hc-tabla--sm">
              <thead><tr>
                <th>N° Licencia</th><th>Fecha</th><th>Entidad</th><th>Estado</th>
              </tr></thead>
              <tbody>
                <tr v-for="(m,i) in multasRunt(sel)" :key="i">
                  <td class="hc-mono">{{ m.nro_licencia }}</td>
                  <td>{{ m.fecha_expedicion }}</td>
                  <td>{{ m.ot_expide_lic }}</td>
                  <td><span :class="['hc-status', m.estado==='ACTIVA'?'hc-status--ok':'hc-status--warn']">{{ m.estado }}</span></td>
                </tr>
              </tbody>
            </table>
          </TabPanel>

          <!-- Antecedentes -->
          <TabPanel>
            <template #header><i class="pi pi-shield mr-2"></i>Antecedentes</template>
            <div class="hc-seccion-grid">
              <div class="hc-seccion">
                <div class="hc-seccion-titulo"><i class="pi pi-shield"></i> Policía Nacional</div>
                <div class="hc-kv-grid">
                  <span class="hc-kv-lbl">Tiene antecedentes</span>
                  <span><span :class="['hc-status', tieneAntecedentes(sel)?'hc-status--danger':'hc-status--ok']">{{ tieneAntecedentes(sel)?'SÍ':'NO' }}</span></span>
                  <span class="hc-kv-lbl">Tipo doc.</span>
                  <span class="hc-mono">{{ _policia(sel)?.tipo_doc || '—' }}</span>
                </div>
              </div>
              <div class="hc-seccion">
                <div class="hc-seccion-titulo"><i class="pi pi-lock"></i> Contraloría (PROC)</div>
                <div class="hc-kv-grid">
                  <span class="hc-kv-lbl">Reportado</span>
                  <span><span :class="['hc-status', _contra(sel)?.reportado?'hc-status--danger':'hc-status--ok']">{{ _contra(sel)?.reportado?'SÍ':'NO' }}</span></span>
                  <span class="hc-kv-lbl">Estado</span>         <span>{{ _contra(sel)?.estado || '—' }}</span>
                  <span class="hc-kv-lbl">Tipo documento</span> <span>{{ _contra(sel)?.tipo_documento || '—' }}</span>
                  <span class="hc-kv-lbl">Cód. verificación</span>
                  <span class="hc-mono" style="font-size:.7rem;word-break:break-all">{{ _contra(sel)?.codigo_verificacion || '—' }}</span>
                </div>
              </div>
            </div>
          </TabPanel>

          <!-- Fotos -->
          <TabPanel>
            <template #header><i class="pi pi-images mr-2"></i>Documentos y Fotos</template>
            <div class="hc-fotos-grid">
              <div class="hc-foto-card">
                <div class="hc-foto-label">Selfie conductor</div>
                <img v-if="cAttr(sel,'Foto_conductor_url')" :src="cAttr(sel,'Foto_conductor_url')" class="hc-foto-doc" alt="selfie" />
                <div v-else class="hc-foto-placeholder-lg"><i class="pi pi-user"></i></div>
              </div>
              <div class="hc-foto-card">
                <div class="hc-foto-label">Cédula (frontal)</div>
                <img v-if="cAttr(sel,'Foto_cedula_frontal_url')" :src="cAttr(sel,'Foto_cedula_frontal_url')" class="hc-foto-doc" alt="cédula" />
                <div v-else class="hc-foto-placeholder-lg"><i class="pi pi-id-card"></i></div>
              </div>
              <div class="hc-foto-card">
                <div class="hc-foto-label">Cédula (anverso)</div>
                <img v-if="cAttr(sel,'foto_cedula_anverso_url')" :src="cAttr(sel,'foto_cedula_anverso_url')" class="hc-foto-doc" alt="cédula anverso" />
                <div v-else class="hc-foto-placeholder-lg"><i class="pi pi-id-card"></i></div>
              </div>
              <div class="hc-foto-card">
                <div class="hc-foto-label">Licencia (frontal)</div>
                <img v-if="cAttr(sel,'foto_licencia_de_conduccion_frontal_url')" :src="cAttr(sel,'foto_licencia_de_conduccion_frontal_url')" class="hc-foto-doc" alt="licencia" />
                <div v-else class="hc-foto-placeholder-lg"><i class="pi pi-car"></i></div>
              </div>
              <div class="hc-foto-card">
                <div class="hc-foto-label">Licencia (anverso)</div>
                <img v-if="cAttr(sel,'foto_licencia_de_conduccion_anverso_url')" :src="cAttr(sel,'foto_licencia_de_conduccion_anverso_url')" class="hc-foto-doc" alt="licencia anverso" />
                <div v-else class="hc-foto-placeholder-lg"><i class="pi pi-car"></i></div>
              </div>
            </div>
          </TabPanel>

        </TabView>
      </div>
      <template #footer>
        <button class="hc-btn-outline" @click="modalDetalle = false">
          <i class="pi pi-times"></i> Cerrar
        </button>
      </template>
    </Dialog>

    </template>

    <ModalNuevoConductor
      v-if="mostrarModalNuevo"
      v-model="mostrarModalNuevo"
      :id-rol="idRolActivo"
      :id-customer="customer_selected"
      :documento-inicial="resincronizandoExistente ? _docResincronizar : ''"
      :tipo-documento-inicial="resincronizandoExistente ? _tipoDocResincronizar : 1"
      :fecha-expedicion-inicial="resincronizandoExistente ? _fechaExpResincronizar : null"
      :modo-resincronizar="resincronizandoExistente"
      @guardado="onGuardadoOResincronizado"
      @hide="onCerrarModal"
    />
  </div>
</template>

<script>
import ModalNuevoConductor from './modalHvConductor.vue';

export default {
  components: { ModalNuevoConductor },

  data() {
    return {
      mostrarModalNuevo: false,
      idRolActivo:       null,
      customers_group:   [],
      customer_selected: null,
      conductores:       [],
      loader:            false,
      modalDetalle:      false,
      sel:               null,
      resincronizandoExistente:  false,
      _docResincronizar:         '',
      _tipoDocResincronizar:     1,
      _fechaExpResincronizar:    null,
      _rowResincronizando:       null,
      porPagina: 25,
      pagination: { current_page:1, from:0, to:0, total:0, per_page:25, last_page:1 },
      frmfiltros: { busqueda:'', estado_conductor:null, estado_licencia:null, tiene_comparendos:null, tiene_antecedentes:null },
      opciones_estado_conductor: [{ label:'Activo',value:'ACTIVO' },{ label:'Inactivo',value:'INACTIVO' }],
      opciones_estado_licencia:  [{ label:'Activa',value:'ACTIVA' },{ label:'Vencida',value:'VENCIDA' },{ label:'Retenida',value:'RETENIDA' }],
      opciones_si_no:            [{ label:'Sí',value:1 },{ label:'No',value:0 }],
    };
  },

  mounted() {
    const cookie = {};
    document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });
    this.idRolActivo = cookie['IdRol'] ?? null;
    if (String(this.idRolActivo) === '2') {
      this.cargarEmpresas();
    } else {
      this.cargarConductores(1);
    }
  },

  methods: {
    cargarEmpresas() {
      this.loader = true;
      const cookie = {};
      document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });
      window.api.call('post', '/cargar_customers?&page=1', {
        email: cookie['Email'], id_rol: cookie['IdRol'],
      }).then(res => {
        if (res.status === 200) {
          this.customers_group = res.data.data;
          if (res.data.data.length === 1) {
            this.customer_selected = res.data.data[0].id_customer;
            this.cargarConductores(1);
          } else {
            this.loader = false;
          }
        }
      }).catch(() => {
        this.loader = false;
        this.$toast.add({ severity:'error', summary:'Error', detail:'No se pudo cargar las empresas', life:5000 });
      });
    },

    onEmpresaSeleccionada() {
      if (this.customer_selected == null) return;
      this.cargarConductores(1);
    },

    toggleFiltros(event) { this.$refs.opFiltros.toggle(event); },
    aplicarFiltros()  { this.$refs.opFiltros.hide(); this.cargarConductores(1); },
    limpiarFiltros()  {
      this.frmfiltros = { busqueda:'', estado_conductor:null, estado_licencia:null, tiene_comparendos:null, tiene_antecedentes:null };
      this.$refs.opFiltros.hide();
      this.cargarConductores(1);
    },

    cargarConductores(page) {
      this.loader = true;
      const cookie = {};
      document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });
      window.api.call('post', `/cargar_conductores_hv?page=${page}`, {
        email: cookie['Email'], id_rol: cookie['IdRol'], id_customer: this.customer_selected,
        frmfiltros: this.frmfiltros, per_page: this.porPagina,
      }).then(res => {
        if (res.status === 200) {
          const raw = res.data.data?.data ?? [];
          this.conductores = raw.map(c => ({ ...c, _json: this._parseJson(c.data_json), _sincronizando:false, _sync_estado:null }));
          const meta = res.data.data;
          this.pagination = { current_page:meta.current_page, from:meta.from??0, to:meta.to??0, total:meta.total, per_page:meta.per_page, last_page:meta.last_page };
        }
      }).catch(() => {
        this.$toast.add({ severity:'error', summary:'Error', detail:'No se pudo cargar la lista', life:5000 });
      }).finally(() => { this.loader = false; });
    },

    _parseJson(raw) {
      if (!raw) return null;
      try { return typeof raw === 'string' ? JSON.parse(raw) : raw; } catch { return null; }
    },

    onChangePage(event) { this.cargarConductores(event.page + 1); },

    nombreCompleto(row) {
      const j = row._json;
      if (j) {
        if (j.Nombre_Completo) return j.Nombre_Completo;
        const n = j.runtp?.datos_persona?.nombre_completo ?? j.data_json?.runtp?.datos_persona?.nombre_completo;
        if (n) return n;
        const b = j.ruaf?.informacion_basica?.filas?.[0] ?? j.ruaf?.informacion_basica?.[0]
               ?? j.data_json?.ruaf?.informacion_basica?.filas?.[0] ?? j.data_json?.ruaf?.informacion_basica?.[0];
        if (b) { const p=[b.primer_nombre,b.segundo_nombre,b.primer_apellido,b.segundo_apellido].filter(Boolean).join(' ').trim(); if(p) return p; }
      }
      return row.nombre || row.document_id || '—';
    },

    fotoConductor(row) { return row._json?.Foto_conductor_url ?? null; },

    cAttr(row, campo) {
      const j = row._json;
      if (!j) return null;
      if (j[campo] !== undefined && j[campo] !== null) return j[campo];
      const b = j?.ruaf?.informacion_basica?.filas?.[0] ?? j?.ruaf?.informacion_basica?.[0] ?? null;
      const mapa = {
        'Nombres': b ? [b.primer_nombre,b.segundo_nombre].filter(Boolean).join(' ') : null,
        'Apellidos': b ? [b.primer_apellido,b.segundo_apellido].filter(Boolean).join(' ') : null,
        'Nombre_Completo': j?.runtp?.datos_persona?.nombre_completo ?? null,
        'Email': null, 'Celular': null,
        'Tipo_documento': j?.contra?.tipo_documento ?? null,
      };
      return mapa[campo] ?? null;
    },

    licenciasList(row) {
      const j = row._json;
      if (!j) return [];
      const v1 = j?.data_json?.runtp?.secciones?.licencias_de_conduccion?.registros;
      if (Array.isArray(v1)) return v1;
      const v2 = j?.runtp?.secciones?.licencias_de_conduccion?.filas;
      if (Array.isArray(v2)) return v2;
      return [];
    },

    licenciaEstado(row) {
      const list = this.licenciasList(row);
      if (!list.length) return { label:'Sin datos', cls:'hc-status--sec' };
      if (list.find(l => l.estado==='ACTIVA'))   return { label:'ACTIVA',   cls:'hc-status--ok' };
      if (list.find(l => l.estado==='RETENIDA')) return { label:'RETENIDA', cls:'hc-status--danger' };
      return { label:'VENCIDA', cls:'hc-status--warn' };
    },

    licenciaVence(row) {
      const list = this.licenciasList(row);
      if (!list.length) return '';
      const lic = list.find(l => l.estado==='ACTIVA') ?? list[0];
      return lic.fecha_expedicion ? `Exp: ${lic.fecha_expedicion}` : '';
    },

    _simit(row)  { const j=row._json; return j?.data_json?.simit ?? j?.simit ?? null; },
    _runtp(row)  { const j=row._json; return j?.data_json?.runtp ?? j?.runtp ?? null; },
    _ruaf(row)   { const j=row._json; return j?.data_json?.ruaf  ?? j?.ruaf  ?? null; },
    _policia(row){ const j=row._json; return j?.data_json?.policia ?? j?.policia ?? null; },
    _contra(row) { const j=row._json; return j?.data_json?.contra  ?? j?.contra  ?? null; },

    comparendosList(row) { return this._simit(row)?.comparendos ?? []; },
    nComparendos(row)    { return this._simit(row)?.resumen?.comparendos ?? this.comparendosList(row).length; },
    totalMultas(row)     { return this._simit(row)?.resumen?.total_pagar ?? 0; },
    estadoConductor(row) { return this._runtp(row)?.datos_persona?.estado_conductor ?? '—'; },
    multasRunt(row)      { const sec=this._runtp(row)?.secciones?.multas_e_infracciones; return sec?.registros ?? sec?.filas ?? []; },
    tieneAntecedentes(row) { return this._policia(row)?.tiene_antecedentes===true || this._contra(row)?.reportado===true; },

    verDetalle(row) { this.sel = row; this.modalDetalle = true; },

    resincronizar(row) {
      this._rowResincronizando   = row;
      row._sync_estado           = null;
      row._sincronizando         = false;
      this._docResincronizar     = row.document_id;
      this._fechaExpResincronizar = row.fecha_expedicion_documento ?? null;
      if (row.tipo_documento) {
        this._tipoDocResincronizar = Number(row.tipo_documento);
      } else {
        const t = row._json?.contra?.tipo_documento ?? '';
        const m = {'cédula de ciudadanía':1,'tarjeta de identidad':2,'cédula de extranjería':3,'pasaporte':4,'número de identificación tributaria':5,'carnet diplomático':6,'registro civil':7,'permiso por protección temporal':8};
        this._tipoDocResincronizar = m[t.toLowerCase()] ?? 1;
      }
      this.resincronizandoExistente = true;
      this.mostrarModalNuevo = true;
    },

    onGuardadoOResincronizado() {
      if (this.resincronizandoExistente && this._rowResincronizando) {
        this._rowResincronizando._sync_estado = 'ok';
        this._rowResincronizando._sincronizando = false;
        this._rowResincronizando = null;
        this.resincronizandoExistente = false;
      }
      this.cargarConductores(this.pagination.current_page);
    },

    onCerrarModal() {
      if (this.resincronizandoExistente && this._rowResincronizando) {
        this._rowResincronizando._sincronizando = false;
        this._rowResincronizando = null;
      }
      this.resincronizandoExistente = false;
      this.mostrarModalNuevo = false;
    },

    fmtCOP(valor) {
      if (!valor && valor !== 0) return '—';
      let v = typeof valor==='string' ? parseFloat(valor.replace(/\./g,'').replace(',','.')) : valor;
      if (isNaN(v)) return '—';
      return new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v);
    },
    fmtFechaISO(f) {
      if (!f) return '—';
      const [y,m,d] = String(f).substring(0,10).split('-');
      if (!y||!m||!d) return f;
      return `${d}/${m}/${y}`;
    },
    fmtFecha(f) {
      if (!f) return '—';
      return new Date(f).toLocaleDateString('es-CO',{day:'2-digit',month:'short',year:'numeric'});
    },
  },
};
</script>

<style scoped lang="scss">
$navy:#0A354E; $white:#fff; $g200:#e8eaed; $g500:#6b7280; $g700:#374151; $r:16px; $bg:#f7f7f7;

.hc-wrap { background:$bg; min-height:100vh; padding:1.25rem .5rem; }

/* ── Selección de empresa ── */
.hc-empresa-selector { display:flex; align-items:center; gap:1rem; background:$white; border:1px solid $g200; border-radius:$r; padding:1.25rem 1.5rem; margin-bottom:1.25rem; }
.hc-empresa-icon { width:44px; height:44px; border-radius:10px; background:#eff6ff; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:1.2rem;color:#1e40af;} }
.hc-empresa-body { flex:1; }
.hc-empresa-title { font-size:.85rem; font-weight:700; color:$g700; margin-bottom:.5rem; }

/* ── Topbar ── */
.hc-topbar { display:flex; justify-content:space-between; align-items:center; margin-bottom:1.25rem; flex-wrap:wrap; gap:.75rem; }
.hc-title  { font-size:1.35rem; font-weight:700; color:$g700; margin:0 0 .2rem; display:flex; align-items:center; gap:.6rem; }
.hc-sub    { font-size:.8rem; color:$g500; margin:0; }
.hc-topbar-actions { display:flex; gap:.65rem; }
.hc-badge-total { display:inline-flex; align-items:center; justify-content:center; background:#dbeafe; color:#1d4ed8; font-size:.72rem; font-weight:700; border-radius:20px; padding:.1rem .6rem; }

/* ── Buttons ── */
.hc-btn-primary { display:inline-flex; align-items:center; gap:.35rem; background:$navy; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:background .15s; i{font-size:13px;} &:hover{background:#0c4f77;} &:disabled{opacity:.6;cursor:not-allowed;} }
.hc-btn-outline  { display:inline-flex; align-items:center; gap:.35rem; background:$white; color:$g700; border:1px solid $g200; border-radius:8px; padding:.45rem .9rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:all .15s; i{font-size:13px;} &:hover{border-color:$navy;color:$navy;} }
.hc-btn-icon { display:inline-flex; align-items:center; justify-content:center; width:30px; height:30px; background:$white; border:1px solid $g200; border-radius:6px; cursor:pointer; color:$g700; font-size:.82rem; transition:all .15s; &:hover{border-color:$navy;color:$navy;} &:disabled{opacity:.5;cursor:not-allowed;} }
.hc-btn-icon--ok     { color:#16a34a; border-color:#86efac; background:#f0fdf4; }
.hc-btn-icon--warn   { color:#d97706; border-color:#fcd34d; background:#fffbeb; }
.hc-btn-icon--danger { color:#dc2626; border-color:#fca5a5; background:#fef2f2; }

/* ── Filtros ── */
.hc-filtros { padding:.25rem; display:flex; flex-direction:column; gap:.875rem; }
.hc-filtros-title { display:flex; align-items:center; gap:.5rem; font-size:.9rem; font-weight:700; color:$navy; padding-bottom:.75rem; border-bottom:1px solid $g200; i{font-size:14px;} }
.hc-filtros-grid  { display:grid; grid-template-columns:1fr 1fr; gap:.75rem; }
.hc-filtros-field { display:flex; flex-direction:column; gap:.3rem; label{font-size:.68rem;font-weight:700;color:$g500;text-transform:uppercase;letter-spacing:.5px;} }
.hc-filtros-actions { display:flex; justify-content:flex-end; gap:.65rem; padding-top:.75rem; border-top:1px solid $g200; }

/* ── Tabla ── */
.hc-tabla-wrap { background:$white; border:1px solid $g200; border-radius:$r; overflow:hidden; }
.hc-tabla { width:100%; border-collapse:collapse; font-size:.82rem; }
.hc-tabla thead tr { background:#f8f9fa; }
.hc-tabla th { text-align:left; padding:.65rem 1rem; font-size:.63rem; font-weight:700; letter-spacing:.7px; text-transform:uppercase; color:$g500; border-bottom:1px solid $g200; white-space:nowrap; }
.hc-tabla td { padding:.75rem 1rem; border-bottom:1px solid #f1f3f4; color:$g700; vertical-align:middle; }
.hc-tabla tbody tr:last-child td { border-bottom:none; }
.hc-tabla tbody tr:hover td { background:#fafbfc; }
.hc-tabla--sm th, .hc-tabla--sm td { padding:.55rem .75rem; }

/* Celdas */
.hc-foto-wrap { width:40px; height:40px; border-radius:50%; overflow:hidden; border:2px solid $g200; }
.hc-foto { width:100%; height:100%; object-fit:cover; }
.hc-foto-placeholder { width:40px; height:40px; border-radius:50%; background:#e2e8f0; display:flex; align-items:center; justify-content:center; i{color:#94a3b8;font-size:1.1rem;} }
.hc-doc-badge { display:inline-block; background:$navy; color:white; font-weight:700; font-size:.75rem; padding:3px 10px; border-radius:5px; letter-spacing:.5px; font-family:monospace; }
.hc-doc-badge-lg { display:inline-block; background:white; color:$navy; font-size:1rem; font-weight:800; padding:3px 12px; border-radius:6px; letter-spacing:1px; font-family:monospace; }
.hc-strong { font-weight:600; color:$g700; font-size:.85rem; }
.hc-sub    { font-size:.72rem; color:#94a3b8; margin-top:2px; }
.hc-rojo   { color:#dc2626 !important; }
.hc-mono   { font-family:monospace; font-size:.79rem; color:$g700; }
.hc-bold   { font-weight:700; }
.hc-tag-sec { display:inline-block; background:#f1f5f9; color:#64748b; font-size:.68rem; font-weight:600; padding:1px 6px; border-radius:4px; }
.hc-sync-fecha { font-size:.76rem; color:#64748b; }
.hc-acciones   { display:flex; gap:.35rem; }

/* Status */
.hc-status { display:inline-block; font-size:.7rem; font-weight:700; padding:.2rem .55rem; border-radius:20px; white-space:nowrap; }
.hc-status--ok     { background:#f0fdf4; color:#16a34a; }
.hc-status--danger { background:#fef2f2; color:#dc2626; }
.hc-status--warn   { background:#fffbeb; color:#d97706; }
.hc-status--sec    { background:#f1f5f9; color:#64748b; }
.hc-status--info   { background:#eff6ff; color:#2563eb; }

/* Count */
.hc-count { display:inline-flex; align-items:center; justify-content:center; min-width:24px; height:24px; padding:0 6px; border-radius:12px; font-size:.78rem; font-weight:700; }
.hc-count--ok     { background:#f0fdf4; color:#16a34a; }
.hc-count--danger { background:#fef2f2; color:#dc2626; }
.hc-count--warn   { background:#fffbeb; color:#d97706; }

/* Paginación */
.hc-pagination { display:flex; justify-content:space-between; align-items:center; padding:.75rem 1rem; border-top:1px solid $g200; flex-wrap:wrap; gap:.5rem; font-size:.78rem; color:$g500; }
.hc-pagination-left { display:flex; align-items:center; gap:.5rem; }
.hc-pag-label { font-size:.75rem; color:$g500; }
.hc-per-page  { border:1px solid $g200; border-radius:6px; padding:.25rem .5rem; font-size:.78rem; color:$g700; background:$white; cursor:pointer; &:focus{outline:none;border-color:$navy;} }
.hc-pag-info  { font-size:.78rem; color:$g500; }
.hc-paginator { background:transparent; border:none; }

/* Empty */
.hc-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:5rem 2rem; text-align:center; h3{color:$g700;margin-bottom:.5rem;} p{color:$g500;margin-bottom:1.5rem;} }
.hc-empty-icon { width:80px; height:80px; background:#e0f2fe; border-radius:50%; display:flex; align-items:center; justify-content:center; margin-bottom:1.25rem; i{font-size:2.5rem;color:#0369a1;} }

/* Skeleton */
@keyframes shimmer { 0%{background-position:-600px 0} 100%{background-position:600px 0} }
.hc-skeleton-row { height:52px; border-radius:6px; background:linear-gradient(90deg,#ececec 25%,#f5f5f5 50%,#ececec 75%); background-size:1200px; animation:shimmer 1.4s infinite linear; }

/* ── Modal ── */
.hc-dialog {
  :deep(.p-dialog-header) { font-weight:700; font-size:1rem; border-bottom:1px solid $g200; }
  :deep(.p-dialog-content){ padding:1.5rem; }
  :deep(.p-dialog-footer) { border-top:1px solid $g200; padding:1rem 1.5rem; display:flex; justify-content:flex-end; gap:.65rem; }
}

.hc-modal-header { display:flex; align-items:flex-start; gap:1.25rem; background:linear-gradient(135deg,#0A354E 0%,#0c4f77 100%); border-radius:10px; padding:1.25rem 1.5rem; color:white; flex-wrap:wrap; }
.hc-foto-header-wrap { width:72px; height:72px; border-radius:50%; overflow:hidden; border:3px solid rgba(255,255,255,.3); flex-shrink:0; }
.hc-foto-header { width:100%; height:100%; object-fit:cover; }
.hc-foto-header-placeholder { width:72px; height:72px; border-radius:50%; background:rgba(255,255,255,.15); display:flex; align-items:center; justify-content:center; i{font-size:2rem;color:white;} }
.hc-modal-main  { flex:1; min-width:180px; }
.hc-modal-title { font-size:1.05rem; font-weight:700; margin-top:4px; }
.hc-modal-sub   { font-size:.75rem; color:rgba(255,255,255,.7); margin-top:3px; }
.hc-modal-badges{ display:flex; gap:1.25rem; flex-wrap:wrap; align-items:flex-start; }
.hc-badge-item  { display:flex; flex-direction:column; align-items:center; gap:4px; }
.hc-badge-lbl   { font-size:.65rem; color:rgba(255,255,255,.7); font-weight:600; text-transform:uppercase; }

/* Secciones */
.hc-seccion-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(240px,1fr)); gap:1rem; }
.hc-seccion { border:1px solid #e5e7eb; border-radius:8px; padding:1rem; background:#fafbfc; }
.hc-seccion-titulo { font-size:.72rem; font-weight:700; color:$navy; text-transform:uppercase; letter-spacing:.5px; margin-bottom:.75rem; display:flex; align-items:center; gap:6px; i{font-size:.78rem;} }
.hc-kv-grid { display:grid; grid-template-columns:130px 1fr; gap:.35rem .5rem; font-size:.8rem; }
.hc-kv-lbl  { font-weight:600; color:#64748b; }

/* Póliza / licencia */
.hc-poliza-card { border:1px solid #e5e7eb; border-radius:8px; padding:1rem 1.25rem; margin-bottom:.75rem; background:#f9fafb; &.hc-poliza-vigente{border-color:#86efac;background:#f0fdf4;} }
.hc-poliza-header { display:flex; justify-content:space-between; align-items:center; margin-bottom:.75rem; }
.hc-poliza-entidad { font-weight:700; font-size:.85rem; color:$g700; }
.hc-poliza-kv { display:grid; grid-template-columns:repeat(auto-fit,minmax(150px,1fr)); gap:.4rem 1rem; font-size:.8rem; div{display:flex;flex-direction:column;gap:1px;} }

/* SIMIT */
.hc-simit-clean { display:flex; flex-direction:column; align-items:center; padding:2.5rem 1rem; text-align:center; gap:.5rem; strong{font-size:1rem;color:#166534;} p{color:#4b7a60;font-size:.875rem;margin:0;} }
.hc-simit-icon  { font-size:3rem; color:#22c55e; }
.hc-deuda-resumen { display:flex; justify-content:space-around; flex-wrap:wrap; gap:.5rem; padding:.875rem 1.25rem; background:#fef2f2; border:1px solid #fecaca; border-radius:8px; }
.hc-deuda-item  { display:flex; flex-direction:column; align-items:center; gap:.3rem; }
.hc-deuda-total { font-size:1rem; color:#dc2626; font-weight:700; }
.hc-monto       { color:#dc2626; font-weight:600; font-size:.81rem; }
.hc-tab-badge   { display:inline-flex; align-items:center; justify-content:center; width:18px; height:18px; background:#dc2626; color:white; border-radius:50%; font-size:.65rem; font-weight:700; margin-left:.4rem; }
.hc-tab-badge--warn { background:#d97706; }
.hc-empty-tab   { display:flex; align-items:center; gap:.5rem; padding:2rem 1rem; color:#94a3b8; font-size:.875rem; i{font-size:1.25rem;} }

/* Fotos */
.hc-fotos-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(180px,1fr)); gap:1rem; padding:.5rem 0; }
.hc-foto-card  { border:1px solid #e5e7eb; border-radius:8px; overflow:hidden; background:#fafbfc; text-align:center; }
.hc-foto-label { font-size:.72rem; font-weight:600; color:#64748b; padding:.5rem; background:#f1f5f9; border-bottom:1px solid #e5e7eb; }
.hc-foto-doc   { width:100%; height:160px; object-fit:cover; display:block; }
.hc-foto-placeholder-lg { height:160px; display:flex; align-items:center; justify-content:center; background:#f1f5f9; i{font-size:3rem;color:#cbd5e1;} }

/* Responsive */
@media(max-width:768px) {
  .hc-topbar { flex-direction:column; align-items:flex-start; }
  .hc-modal-header { flex-direction:column; }
  .hc-seccion-grid { grid-template-columns:1fr; }
  .hc-kv-grid { grid-template-columns:110px 1fr; }
  .hc-filtros-grid { grid-template-columns:1fr; }
  .hc-fotos-grid { grid-template-columns:repeat(2,1fr); }
  .hc-tabla { font-size:.75rem; }
  .hc-tabla th, .hc-tabla td { padding:.5rem .6rem; }
}
</style>